import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import Lab from './pages/Lab';
import { ModalProvider } from './context/ModalContext';

function App() {
  return (
    <Router>
      <ModalProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/lab" element={<Lab />} />
          </Routes>
        </Layout>
      </ModalProvider>
    </Router>
  );
}

export default App;